/* eslint-disable */

const convertMinutesToHoursAndMinutes = minutes => {
  return `${minutes} Min`;
};

export default convertMinutesToHoursAndMinutes;
